module.exports = __webpack_public_path__ + "static/media/saLogo.a7d2522a.jpg";